import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_ROUTE_DATA = 'SET_ROUTE_DATA';
export const setRouteData = makeActionCreator(SET_ROUTE_DATA);
